export function trackProfileVisit(userName){
  if (!userName) return;
  try {
    // persist last user for 180 days
    const expires = new Date(Date.now() + 180*24*60*60*1000).toUTCString();
    localStorage.setItem('last_user', userName);
    // keep backward compatibility
    document.cookie = `last_user=${encodeURIComponent(userName)}; path=/; expires=${expires}`;
    document.cookie = `ref_last=${encodeURIComponent(userName)}; path=/; expires=${expires}`;
  } catch(e) { void e }
}
